import $ from 'jquery';
import tippy from 'tippy.js';

export const init = () => {

	tippy('.tippy', {
		animation: 'shift-toward',
		arrow: true,
		arrowType: 'sharp',
		arrowTransform: 'scaleX(1.3)',
		duration: 500,
		size: 'large',
		placement: 'bottom',
		position: 'bottom-start',
		theme: 'light',
		hideOnClick: false,
	});

	$(document)
		.on('click', '.tippy', function(e) {
			if ($(this).is(':not(button)')) {
				e.preventDefault();
			}
		});
};
